<div class="input-wrapper">
  <ng-content *ngIf="prefixIcon"></ng-content>
  <input
    #inputField
    [ngStyle]="textColor"
    [name]="name"
    [class]="className"
    class="finx-input"
    [maxLength]="maxLength"
    [placeholder]="placeholder"
    [attr.aria-label]="ariaLabel || null"
    [type]="type"
    (keypress)="error && onKeypress()"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (change)="onChange($event)"
    (ngModelChange)="onNgModelChange($event)"
    [disabled]="isDisabled || readOnly"
    [value]="value"
    (keyup)="onKeyup($event)"
    [formControl]="inputStringControl"
    [ngModel]="value"
    [checked]="checked"
    [min]="minValue"
    [max]="maxValue"
    [step]="step"
    [class.is-disabled]="isDisabled"
    [class.disabled-input]="isDisabled"
    [class.prefix-icon]="prefixIcon"
    [class.text-center]="textAlignCenter"
    [class.bg-color-lighterblue]="bgColorLighterblue"
    [class.bold-text]="isTextBold"
    [ngClass]="{ 'invalid-input': formControlStatus }"
  />
</div>
